/**
 * 发货单常量定义
 * @module types/shipment/constants
 * @description 发货单相关的常量和标签映射
 * @last-updated 2025-12-26
 */

import { ShipmentStatus, ShippingMethod } from './enums';

/**
 * 发货单状态标签映射
 * @对应后端 Shipment::getStatuses()
 */
export const SHIPMENT_STATUS_LABELS: Record<ShipmentStatus, string> = {
  [ShipmentStatus.PENDING]: '待发货',
  [ShipmentStatus.SHIPPED]: '已发货',
  [ShipmentStatus.RECEIVED]: '已签收',
  [ShipmentStatus.CANCELLED]: '已取消',
};

/**
 * 发货单状态颜色映射（用于前端展示）
 */
export const SHIPMENT_STATUS_COLORS: Record<ShipmentStatus, string> = {
  [ShipmentStatus.PENDING]: 'warning',
  [ShipmentStatus.SHIPPED]: 'processing',
  [ShipmentStatus.RECEIVED]: 'success',
  [ShipmentStatus.CANCELLED]: 'error',
};

/**
 * 发货方式标签映射
 * @对应后端 Shipment::getShippingMethods()
 */
export const SHIPPING_METHOD_LABELS: Record<ShippingMethod, string> = {
  [ShippingMethod.EXPRESS]: '快递',
  [ShippingMethod.LOGISTICS]: '物流',
  [ShippingMethod.SELF_PICKUP]: '自提',
};
